import React from 'react'
import classes from "./DetailBlock.module.css";
const DetailBlock = ({label,value}) => {
  return (
    <div className={classes.wrapper}>

      <h3 className={classes.label}>{label}</h3>
      <p className={classes.value}>{value}</p>
    </div>
  )
}

export default DetailBlock